import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { AuthStatus } from '@interfaces/auth-status.model';
import { SearchOverlayData } from '@interfaces/search-overlay-data.model';
import { SearchTrigger } from './search-trigger.class';
import { FeaturesService } from '../services/features/features.service';
import { SubscriptionManager } from '@zelis/platform-ui-components';

@Injectable({
  providedIn: 'root',
})
export class SearchOverlay {
  public dialogRef: MatDialogRef<any>;
  private term: string;
  private auth: boolean;
  private costEnabled: boolean;
  private subscriptions = new SubscriptionManager();

  constructor(
    public dialog: MatDialog,
    private searchTrigger: SearchTrigger,
    private featuresService: FeaturesService
  ) {
    this.subscriptions.add(this.subscribeToFeatures());
  }

  public open(
    component: any,
    term: string,
    auth: AuthStatus
  ): MatDialogRef<any> | void {
    this.term = term;
    this.auth = auth.auth_status;

    if (term && term.length > 2) {
      this.dialogRef = this.dialog.open(component, {
        width: '99.9%',
        maxWidth: '784px',
        data: this.setData(),
        panelClass: 'search-overlay',
        backdropClass: 'search-overlay-backdrop',
      });
      return this.dialogRef;
    }
  }

  public listenForSearch(): Observable<string> {
    // Launch search before modal is done closing
    return this.dialogRef
      .beforeClosed()
      .pipe(filter((action) => action === 'search'));
  }

  public listenForAutosuggest(): Observable<string> {
    // Reopen autosuggest for specialists or procedures searches after modal has closed
    return this.dialogRef
      .afterClosed()
      .pipe(filter((action) => action !== 'search'));
  }

  private setData(): SearchOverlayData {
    return new SearchOverlayData({
      term: this.term,
      auth: this.auth,
      costEnabled: this.costEnabled,
    });
  }

  private subscribeToFeatures(): Subscription {
    return this.featuresService.getFeatureFlags().subscribe((features) => {
      this.costEnabled = features?.cost;
    });
  }
}
